module.exports = __webpack_public_path__ + "img/go.9f5e5f72.svg";